/**
 * Lista que define los tipo de admision
 * que estan registrados en la tabla de programa
 */
export enum TipoAdmisionEnum {
    MANUAL = 1,
    AUTOMATICO = 2
}